import React,{useState,useEffect} from "react"
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {fontColorBlue,hoverTitle,hoverTitleWrap,fontColorDark} from './shared.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera } from '@fortawesome/free-solid-svg-icons'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once. Is it already imported?
import { Link } from "gatsby"

const Amenities = ({amenities,textOnlyAmenities,slug='',citySlug,area})=>{

    const [viewImg, setViewImg] = useState(0);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    let images = [];
    if(amenities){
        amenities.map((i)=>{
            images.push({'img':getImage(i),'title':i.title});
        });
    }
  
    if(textOnlyAmenities){
        textOnlyAmenities.map((amen)=>{
          images.push({'img':'','title':amen});
        })
    }

    images.sort((a, b) => a.title.localeCompare(b.title));

    const handleViewImg = (i) => {
      if (isMobile) {
          setViewImg(i);
          setLightboxOpen(true);
      } else {
          // not mobile
          setViewImg(i);
      }
    };

    useEffect(() => {
      for (let i = 0; i < images.length; i++) {
        if (images[i].img && images[i].img !== '') {
          setViewImg(i);
          break;
        }
      }
    }, [amenities, textOnlyAmenities])

    useEffect(() => {
      function handleResize() {
          setIsMobile(window.innerWidth <= 768); // Example breakpoint for mobile
      }

      window.addEventListener('resize', handleResize);
      handleResize();
      return () => window.removeEventListener('resize', handleResize);
  }, []);

    return(
        <section >
            <div className=" container">
                <div className="columns is-padded">
                    <div className="column ">
                      <h1 className={fontColorBlue} style={{textAlign:'center',fontFamily: "MoonTime",fontSize:'5rem'}}>Amenities</h1>
                      <hr />
                      {images.map((img,i)=>{
                          return (
                            img.img ? 
                            <p onClick={()=>{handleViewImg(i)}} 
                            className={fontColorDark} 
                            style={{cursor:'pointer',marginBottom:'10px'}} 
                            key={i}>{img.title} 
                                <FontAwesomeIcon icon={ faCamera } 
                                size="lg" 
                                className={fontColorBlue}
                                style={{marginLeft:'5px'}} />
                            </p>
                            :
                            <p className={fontColorDark} style={{marginBottom:'10px'}} key={i}>{img.title}</p>
                          )
                      })}
                        <br />
                        <Link to={`/apartments/${area.toLowerCase()}/${citySlug.toLowerCase() }/${slug}/gallery/`} className="button is-link">Photo Gallery</Link>
                    </div>
                    {!isMobile && (
                        <div className="column is-two-thirds">
                            {images[viewImg] && images[viewImg].img && <GatsbyImage image={images[viewImg].img} alt="Images of Amenities" />}
                        </div>
                    )}
                </div>
            </div>
            {lightboxOpen && images[viewImg] && images[viewImg].img && (
    <Lightbox
        mainSrc={images[viewImg].img && images[viewImg].img.images ? images[viewImg].img.images.fallback.src : ''}
        nextSrc={images[(viewImg + 1) % images.length].img && images[(viewImg + 1) % images.length].img.images ? images[(viewImg + 1) % images.length].img.images.fallback.src : ''}
        prevSrc={images[(viewImg + images.length - 1) % images.length].img && images[(viewImg + images.length - 1) % images.length].img.images ? images[(viewImg + images.length - 1) % images.length].img.images.fallback.src : ''}
        onCloseRequest={() => setLightboxOpen(false)}
        onMovePrevRequest={() => setViewImg((viewImg + images.length - 1) % images.length)}
        onMoveNextRequest={() => setViewImg((viewImg + 1) % images.length)}
    />
)}

        </section>
    )
}


export default Amenities
